import React from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children, allowedRoles }) {
  const token = localStorage.getItem('token');
  const userStr = localStorage.getItem('user');
  
  if (!token || !userStr) {
    // Not logged in, redirect to login
    return <Navigate to="/login" replace />;
  }

  try {
    const user = JSON.parse(userStr);
    
    // Check if user role is allowed
    if (allowedRoles && !allowedRoles.includes(user.role)) {
      // User doesn't have permission, redirect based on their role
      if (user.role === 'kasir') {
        return <Navigate to="/kasir" replace />;
      } else if (user.role === 'admin' || user.role === 'supervisor') {
        return <Navigate to="/admin" replace />;
      }
      return <Navigate to="/login" replace />;
    }

    return children;
  } catch (error) {
    // Invalid user data, clear and redirect to login
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    return <Navigate to="/login" replace />;
  }
}

export default ProtectedRoute;
